export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_07.04129f9e.jpg";